module.exports = __webpack_public_path__ + "media/en_us_s5_Susan.8db9f7ac.mp3";